import React, { useMemo } from 'react'
import Card from '../../../components/common/Card'
import Table from '../../../components/common/Table'
import dayjs from 'dayjs'
import { pascalize } from 'humps'
import { replaceStatusDcaPlan, replaceUnderScoreAndCapitalize } from '../../../../utils/helper'
import { DcaList, EnumFrequencyDcaType } from '../../../services/dca/dca-typed'
import styled from '@emotion/styled'
import { Typography } from '@material-ui/core'
import { EnumTransactionType } from '../../../services/transaction/transaction-typed'

const TextLib = styled(Typography)`
  line-height: 2 !important;
`

const TextColor = styled(TextLib)<{ color?: string }>`
  color: ${({ color }) => color};
  font-weight: bold !important;
`

interface IDcaPlansCardProps {
  dcaPlans?:  DcaList
  onPageChange: (page: number) => void

}

const DcaPlansCard = (props: IDcaPlansCardProps) => {
  const { dcaPlans,onPageChange } = props

  const data = useMemo(() => {
    return dcaPlans?.items?.map(e => {
      const { status, type: dcaType, date, value, externalReference, subscriptionId, createdAt } = e

      const dcaDate =
        dcaType === EnumFrequencyDcaType.MONTHLY
          ? `Every ${date} of the month`
          : `Every ${dayjs()
              .day(Number(date))
              .format('dddd')}`

      return {
        reference: externalReference || '',
        price: Number(value).toLocaleString() || '',
        status: replaceStatusDcaPlan(status) || '',
        date: dcaDate || '',
        dcaUnit: pascalize(dcaType || ''),
        subscriptionId: subscriptionId || '',
        createdAt: dayjs(createdAt).format('YYYY-MM-DD HH:mm:ss') || '',
      }	
    })
  }, [dcaPlans])

  const columns = useMemo(() => {
    return (
      data?.length &&
      Object.keys(data[0]).map(key => {
        return {
          title: pascalize(key),
          dataIndex: key,
        }
      })
    )
  }, [data])
  return columns ? (
    <Card style={{ marginTop: 10 }}>
      <TextColor variant="h5">DCA Plans</TextColor>
      <Table style={{ marginTop: 10 }} columns={columns} data={data} pagination={dcaPlans?.meta} onPageChange={onPageChange}/>
    </Card>
  ) : (
    <></>
  )
}

export default DcaPlansCard
